export default __webpack_public_path__ + "static/media/avatar.4d421c05.svg";